import React, { useState, useEffect, useMemo } from "react";
import { instance } from "../../axios";
import { PageHeader, UiActioButton, UiTimeDisplay, UiActionDropDown, UiButton, PageError, BgLoader, TableZero } from "../../ui";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup"; 
import { Link, useNavigate, useParams, useLocation, Outlet, useOutletContext } from "react-router-dom";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { Helmet } from "react-helmet";
import { useQueryClient } from 'react-query';
import { DropdownItem } from '@atlaskit/dropdown-menu';
import {rupees} from '../../helper'



export default function ViewLead() {
  let { id } = useParams();
  let navigate = useNavigate();
  const queryClient = useQueryClient()
  const [state, setState] = useState({});
  const [loader, showLoader] = useState({});
  const [vloader, showVLoader] = useState(false);
  const [bg_loader, setBGLoader] = useState(false);
  const handleDelete = (id) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        showLoader({ ...loader, delete: true })
        instance
          .get("/z_update_lead?delete=" + id)
          .then(function (response) {
            showLoader({ ...loader, delete: false })
            if (response.data.status == 'success') {

              queryClient.invalidateQueries(['leads'])
              navigate(-1);
              toast(response.data.msg, { type: "success" });
            } else {
              toast(response.data.msg, { type: "error" });
            }


          })

      }
    })


  }




  const deleteFollowup = (id) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        showLoader({ ...loader, delete: true })
        instance
          .get("/z_update_followup?delete=" + id)
          .then(function (response) {
            showLoader({ ...loader, delete: false })
            if (response.data.status == 'success') {

              fetchData()
              toast(response.data.msg, { type: "success" });
            } else {
              toast(response.data.msg, { type: "error" });
            }


          })

      }
    })


  }



  const deleteDemo = (id) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        showLoader({ ...loader, delete: true })
        instance
          .get("/z_update_demo?delete=" + id)
          .then(function (response) {
            showLoader({ ...loader, delete: false })
            if (response.data.status == 'success') {

              fetchData()
              toast(response.data.msg, { type: "success" });
            } else {
              toast(response.data.msg, { type: "error" });
            }


          })

      }
    })


  }


  const followupmodal = useModal('followup');

  const showFollowup = (row) => {
    followupmodal.show({ data: row, lid: id }).then((res) => {
      fetchData();
    });
  }


  const quotemodal = useModal('quote');

  const showQuote = (row) => {
    quotemodal.show({ data: row, lid: id }).then((res) => {
      fetchData();
    });
  }


  const demoModal = useModal('demo');

  const showDemo = (row) => {
    demoModal.show({ data: row, lid: id }).then((res) => {
      fetchData();
    });
  }


  const leadmodal = useModal('lead');

  const showLead = (row) => {
    leadmodal.show({ data: row }).then((res) => {
      fetchData();
    });
  }

  const fetchData = () => {
    setBGLoader(true)
    instance
      .get("/z_view_lead?id=" + id)
      .then(function (response) {
        setBGLoader(false)

        setState({ ...state, ...response.data });


      })
      .catch(function (error) { })
      .then(function () { });

  }

  useEffect(() => {
    fetchData();
  }, []);



  const BasicDetail = (props) => {
    const { label, val, ...other } = props;
    return (
      <>
        {val &&
          <div className="row mb-3">
            <div className="col-lg-4 text-muted">
              {label}
            </div>
            <div className="col-lg-8" {...other}>

            </div>
          </div>
        }
      </>
    )
  }



  if (state.status == 'error') {
    return (
      <PageError msg={state.msg} code={state.code} />
    )
  }




  return (
    <>
      <Helmet>
        {state.item && (
          <title>
            #{id} | Leads | Practive
          </title>
        )}

      </Helmet>
      <div>
        {state.item ? (
          <>

            <PageHeader title={`#${id}`} parent="Leads" link="/leads" stacked={true}>

              <>
                <button className="btn btn-outline-primary ms-2" onClick={() => showLead(state.item)}>Edit</button>
              </>


              <UiButton className="btn btn-outline-danger ms-2" loading={loader.delete} onClick={() => handleDelete(id)} title="Delete" />

            </PageHeader>





            {bg_loader == true ? <BgLoader /> : (
              <>

                <div className="row">
                  <div className="col-md-6">
                    <div className="card card-default mb-4">
                      <div className="card-body">
                        <BasicDetail label="Created on" val={state.item.created_on}><UiTimeDisplay time={state.item.created_on} /></BasicDetail>
                        <BasicDetail label="Created by" val={state.item.created_by}>{state.item.created_by}</BasicDetail>
                        <BasicDetail label="Assigned to" val={state.item.user_name}>{state.item.user_name}</BasicDetail>
                        <BasicDetail label="Status" val={state.item.status}>{state.item.status}</BasicDetail>
                        <BasicDetail label="Next Follow-up" val={state.item.due_date}>{state.item.due_date}</BasicDetail>
                        <BasicDetail label="Name" val={state.item.name}>{state.item.name}</BasicDetail>
                        <BasicDetail label="Company" val={state.item.company}>{state.item.company}</BasicDetail>
                        <BasicDetail label="Mobile" val={state.item.mobile}>{state.item.mobile}</BasicDetail>
                        <BasicDetail label="Mobile 2" val={state.item.mobile2}>{state.item.mobile2}</BasicDetail>
                        <BasicDetail label="Email" val={state.item.email}>{state.item.email}</BasicDetail>
                        <BasicDetail label="Email 2" val={state.item.email2}>{state.item.email2}</BasicDetail>
                        <BasicDetail label="Address" val={state.item.address}>{state.item.address}</BasicDetail>
                        <BasicDetail label="Remark" val={state.item.remark}>{state.item.remark}</BasicDetail>
                        <BasicDetail label="Source" val={state.item.source}>{state.item.source}</BasicDetail>
                        <BasicDetail label="Tag" val={state.item.tag}><span style={{color:state.item.color}}>{state.item.tag}</span></BasicDetail>



                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="card card-default mb-4">
                      <div className="card-header">
                        <div className="d-flex justify-content-between">
                          <div>
                            Follow-up
                          </div>
                          <div>
                            {state.item.status == 'Open' &&
                              <UiActioButton title="Add" tooltip="New Follow-up" action={() => showFollowup({ status: state.item.status })}></UiActioButton>
                            }
                          </div>
                        </div>
                      </div>
                      <div className="card-body">
                        {state.followup.length == 0 && <TableZero title="Follow-up" />}
                        {state.followup.map((val, i) => (
                          <div className="list1" key={i}>
                            <UiTimeDisplay time={val.created_on} />
                            <div className="mt-2 d-flex justify-content-between">
                              <div>
                                <span className="text-muted">Status:</span> <b>{val.status}</b>
                              </div>
                              <div>
                                <span className="text-muted">Channel:</span> <b>{val.channel}</b>
                              </div>
                            </div>
                            <span className="text-muted">Tag:</span> <b><span style={{color:val.color}}>{val.tag}</span></b>
                            <p className="mt-2 mb-2"><span className="text-muted">Remark</span><br></br>{val.remark}</p>
                            <div className="d-flex justify-content-between">
                              <p className="mb-0"><span className="text-muted">Next Follow-up on:</span> {val.due_date}</p>
                              <UiActionDropDown >
                                <DropdownItem className="text-danger" onClick={() => deleteFollowup(val.id)} >Delete</DropdownItem>

                              </UiActionDropDown>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="card card-default mb-4">
                      <div className="card-header">
                        <div className="d-flex justify-content-between">
                          <div>
                            Demo
                          </div>
                          <div>
                            {state.item.status == 'Open' &&
                              <UiActioButton title="Add" tooltip="New Demo Schedule" action={() => showDemo()}></UiActioButton>
                            }
                          </div>
                        </div>
                      </div>
                      <div className="card-body">
                        {state.demo.length == 0 && <TableZero title="Demo" />}
                        {state.demo.map((val, i) => (
                          <div className="list1" key={i}>
                            
                            <div className="mt-2 d-flex justify-content-between">
                              <div>
                                <span className="text-muted">Demo on:</span> <b>{val.date}</b>
                              </div>
                              <div>
                              <span className="text-muted">Status:</span> <b>{val.status}</b>
                              </div>
                            </div>
                            <p className="mt-2 mb-2"><span className="text-muted">Remark</span><br></br>{val.remark}</p>
                            <div className="d-flex justify-content-between">
                              <p className="mb-0"><UiTimeDisplay time={val.created_on} /></p>
                              <UiActionDropDown >
                                <DropdownItem onClick={() => showDemo(val)} >Edit</DropdownItem>
                                <DropdownItem className="text-danger" onClick={() => deleteDemo(val.id)} >Delete</DropdownItem>

                              </UiActionDropDown>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="card card-default mb-4">
                      <div className="card-header">
                        <div className="d-flex justify-content-between">
                          <div>
                            Quote
                          </div>
                          <div>
                            {state.item.status == 'Open' &&
                              <UiActioButton title="Add" tooltip="New Quote" action={() => showQuote()}></UiActioButton>
                            }
                          </div>
                        </div>
                      </div>
                      <div className="card-body">
                        {state.quote.length == 0 && <TableZero title="Quote" />}
                        {state.quote.map((val, i) => (
                          <div className="list1" key={i}>
                            
                            <div className="mt-2 d-flex justify-content-between">
                              <div>
                                <span className="text-muted">No.:</span> <Link to={`/view-quote/${val.id}`}><b>{val.id}</b></Link>
                              </div>
                              <div>
                              <span className="text-muted">Date:</span> <b>{val.date}</b>
                              </div>
                            </div>
                            <div className="d-flex justify-content-between">
                              <p className="mb-0">Amount: {rupees(val.total)}</p>
                              
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="card card-default mb-4">
                      <div className="card-header">
                        <div className="d-flex justify-content-between">
                          <div>
                            Subscription / Trial
                          </div>
                          <div>
                              <UiActioButton title="Add" tooltip="New Client" action={() => navigate(`/client/new?lead=${state.item.id}`)}></UiActioButton>
                          </div>
                        </div>
                      </div>
                      <div className="card-body">
                        {state.client.length == 0 && <TableZero title="Subscription" />}
                        {state.client.map((val, i) => (
                          <div className="list1" key={i}>
                            
                            <div className="mt-2 d-flex justify-content-between">
                              <div>
                                <span className="text-muted">No.:</span> <Link to={`/view-client/${val.id}`}><b>{val.id}</b></Link>
                              </div>
                              <div>
                              <span className="text-muted">Date:</span> <b>{val.date}</b>
                              </div>
                            </div>
                            <div className="d-flex justify-content-between">
                              <p className="mb-0">Plan: {val.plan} {val.is_trial == 1 ? <span className="badge bg-info">Trial</span> : ''}</p>
                              <p className="mb-0">Status: {val.is_active == 1 ? <span className="text-success">Active</span> : <span className="text-danger">Expired</span>}</p>
                              
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>


              </>
            )}
          </>

        ) : <BgLoader />}


      </div>
    </>
  );
}
